import totalCostReducer from './totalcost';
import paidInFullLanguageReducer from './paidInFullLanguage';
import insuranceBalanceNoteReducer from './insuranceBalanceNote';
import showOTherInputFieldsReducer from './showOTherInputFields';
import showBillingAddressDropReducer from './showBillingAddressDrop';
import showBillingAddressFieldsReducer from './showBillingAddressFields';
import css_insReducer from './css_ins';
import messageDisplayPropertyReducer from './messageDisplayProperty';
import message6DisplayPropertyReducer from './message6DisplayProperty';
import message8DisplayPropertyReducer from './message8DisplayProperty'
import insuranceVendorReducer from './insuranceVendor';
import remainingBalanceNegativeReducer from './remainingBalanceNegative';
import bookingPastDueReducer from './bookingPastDue';
import balanceDueReducer from './balanceDue';
import remainingBalanceReducer from './remainingBalance';
import paymentDueReducer from './paymentDue';
import payRemainingBalanceReducer from './payRemainingBalance';
import minimumPaymentAmountReducer from './minimumPaymentAmount';
import bookingDueTodayReducer from './bookingDueToday';
import paymentOptionReducer from './paymentOption';
import paymentAmountReducer from './paymentAmount';
import remainingBalanceAsFloatReducer from './remainingBalanceAsFloat';
import insuranceStatusReducer from './insuranceStatus';
import paymentOtherReducer from './paymentOther';
import paymentOtherActiveReducer from './paymentOtherActive';
import scheduledPaymentHasChangedReducer from './scheduledPaymentHasChanged';
import ccBillingAddressForVerificationReducer from './ccBillingAddressForVerification';
import confirmViewReducer from './confirmView';
import cssAddress1Reducer from './css_address1';
import cssAddress2Reducer from './css_address2';
import cssCityReducer from './css_city';
import cssPaymentStateReducer from './css_PaymentState';
import ccMonthReducer from './ccMonth';
import ccYearReducer from './ccYear';
import cssZipReducer from './css_zip';
import confirmViewRemainingBalanceReducer from './confirmViewRemainingBalance';
import confirmViewFuturePaymentsReducer from './confirmViewFuturePayments';
import ccHolderForVerificationNameReducer from './ccHolderForVerificationName';
import balancePayRemainingReducer from './balancePayRemaining';
import {combineReducers} from 'redux';


const allReducers = combineReducers({
	totalcost : totalCostReducer,
	paidInFullLanguage : paidInFullLanguageReducer,
	insuranceBalanceNote : insuranceBalanceNoteReducer,
	showOTherInputFields : showOTherInputFieldsReducer,
	showBillingAddressDrop : showBillingAddressDropReducer,
	showBillingAddressFields : showBillingAddressFieldsReducer,
	css_ins : css_insReducer,
	messageDisplayProperty : messageDisplayPropertyReducer,
	message6DisplayProperty : message6DisplayPropertyReducer,
	message8DisplayProperty : message8DisplayPropertyReducer,
	insuranceVendor : insuranceVendorReducer,
	remainingBalanceNegative : remainingBalanceNegativeReducer,
	bookingPastDue : bookingPastDueReducer,
	balanceDue : balanceDueReducer,
	remainingBalance : remainingBalanceReducer,
	paymentDue : paymentDueReducer,
	payRemainingBalance : payRemainingBalanceReducer,
	minimumPaymentAmount : minimumPaymentAmountReducer,
	bookingDueToday : bookingDueTodayReducer,
	paymentOption : paymentOptionReducer,
	paymentAmount : paymentAmountReducer,
	remainingBalanceAsFloat : remainingBalanceAsFloatReducer,
	paymentOther : paymentOtherReducer,
	insuranceStatus: insuranceStatusReducer,
	paymentOtherActive : paymentOtherActiveReducer,
	scheduledPaymentHasChanged : scheduledPaymentHasChangedReducer,
	confirmView : confirmViewReducer,
	ccBillingAddressForVerification : ccBillingAddressForVerificationReducer,
	css_address1 : cssAddress1Reducer,
	css_address2 : cssAddress2Reducer,
	css_city : cssCityReducer,
	css_paymentState : cssPaymentStateReducer,
	css_zip : cssZipReducer,
	ccMonth : ccMonthReducer,
	ccYear : ccYearReducer,
	confirmViewRemainingBalance : confirmViewRemainingBalanceReducer,
	confirmViewFuturePayments : confirmViewFuturePaymentsReducer,
	ccHolderForVerificationName : ccHolderForVerificationNameReducer,
	balancePayRemaining : balancePayRemainingReducer

})
export default allReducers;